<script>
    export let chosenActivity={}
    let chosenActivityBefore={}
    let activity={}
    let constructors =[]
    import {apiUrl} from '../config.svelte';
    import Constructor from './Constructor.svelte'
    import Stat from './Stat/Stat.svelte'

    import { Table,Button, Input, Card,CardBody,Label,FormGroup} from 'sveltestrap';

    import {onMount,onDestroy} from 'svelte';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();



    $:{
        if(chosenActivity!=chosenActivityBefore){
            fetch(apiUrl+"ivm",{
                credentials: "include",
                method:"POST",
                body:JSON.stringify({method:"activity",id:chosenActivity.id}),
                cors:'no-cors'
            })
            .then(x=>x.json())
            .then(x=>{
            if(x.result){
                    activity=x.data
                    loadConstructors()
                }
            })
            .catch((e)=>{

            })
            statShown=false;
            chosenConstructor=undefined;
            chosenActivityBefore=chosenActivity
        }


    }

    function loadConstructors(){
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"constructors",activity:activity.activity}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
        if(x.result){
            constructors=x.data
        }
        })
        .catch((e)=>{

        })
    }
    function ActivateConstructor(constructor){
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"activate-constructor",id:constructor.id}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            loadConstructors()
        })
        .catch((e)=>{
            loadConstructors()
        })
    }
    function createConstructor(){
        let hasNo = true;
        constructors.forEach(x=>{if(newConstructorName.toLowerCase()==x.name.toLowerCase()){hasNo=false}})
        if(newConstructorName.trim()!=""&&hasNo)
        {
            fetch(apiUrl+"ivm",{
                credentials: "include",
                method:"POST",
                body:JSON.stringify({method:"create-constructor",activity:activity.activity,name:newConstructorName}),
                cors:'no-cors'
            })
            .then(x=>x.json())
            .then(x=>{
                if(x.result){
                    newConstructorName="";
                    loadConstructors()
                }
            })
            .catch((e)=>{
                loadConstructors()
            })
        }
    }
    function saveActivity(){
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"update-activity",actvity:activity}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
           if(x.result){
               let activity=x.data
           }
        })
        .catch((e)=>{

        })
    }
    
    let newConstructorName ="";
    let chosenConstructor = undefined;
    let statShown=false;
</script>

{#if !chosenConstructor&& !statShown}
    <Table size="sm" borderless style="width:auto">
        <tr>
            <td></td>
            <td><Button color="info" on:click={()=>{statShown=true}}>статистики</Button></td>
        </tr>
        <tr>
            <td>название</td>
            <td>{activity.activity}</td>
        </tr>
        <tr>
            <td>выключить</td>
            <td><FormGroup check><Input type="checkbox" bind:checked={activity.Block} /></FormGroup></td>
        </tr>
        <tr>
            <td>линий на агента</td>
            <td><Input type="number" bind:value={activity.lineMultiplier} /></td>
        </tr>
        <tr>
            <td>авто выделение линий</td>
            <td><FormGroup check><Input type="checkbox" bind:checked={activity.autoMultiplier} /></FormGroup></td>
        </tr>
        <tr>
            <td></td>
            <td><Button outline color="success" on:click={()=>{saveActivity()}}>Сохранить</Button></td>
        </tr>
    </Table>
    <br/>
    <Table size="sm"  style="width:auto">
        <thead>
            <tr>  
                <th colspan="2">конструкторы</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td><Input type="text" bind:value={newConstructorName} placeholder="название"/></td>
                <td><Button outline color="success" on:click={()=>{createConstructor()}}>добавить</Button></td>
            </tr>
            {#each constructors as constructor}
                <tr style={constructor.inWork?`background-color:rgb(199, 255, 199)`:``}>
                    <td>{constructor.name}</td>
                    <td><Button disabled={constructor.inWork?true:false} outline color="dark" on:click={()=>{ActivateConstructor(constructor)}}>сделать активным</Button></td>
                    <td><Button outline color="dark" on:click={()=>{chosenConstructor = constructor}}>редактировать</Button></td>
                </tr>
            {/each}
        </tbody>
    </Table>

{:else if chosenConstructor}
    <Constructor bind:constructorId={chosenConstructor.id} on:close={()=>{chosenConstructor=undefined}}/>
{:else if statShown}
    <Stat bind:activity on:close={()=>{statShown=false}}/>
{/if}